import { fetchAuthSession } from 'aws-amplify/auth'

import { refreshToken as refreshTokenApi } from '@/api/auth'
import { queryClient } from '@/lib/reactQuery'
import { TLoginType } from '@/typings'
import { ACCESS_TOKEN, ID_TOKEN, LOGIN_TYPE, REFRESH_TOKEN, USER_PREFERENCE } from '@/utils/constant/storage'

export const getAccessToken = async () => {
  const token = localStorage.getItem(ID_TOKEN)
  const loginType = localStorage.getItem(LOGIN_TYPE)

  if (loginType === TLoginType.THIRD_PARTY) {
    const session = await fetchAuthSession()
    return session.tokens?.idToken?.toString() ?? null
  }
  return token
}

export const getNewToken = async () => {
  const loginType = localStorage.getItem(LOGIN_TYPE)
  const token = localStorage.getItem(REFRESH_TOKEN) ?? ''
  const oldToken = localStorage.getItem(ID_TOKEN) ?? ''

  try {
    if (loginType === TLoginType.THIRD_PARTY) {
      await fetchAuthSession({ forceRefresh: true })
      return
    }

    const body = { RefreshToken: token }
    const data = await queryClient.fetchQuery({
      queryKey: ['refreshToken', oldToken],
      queryFn: () => refreshTokenApi(body),
    })
    setNewToken(data.IdToken, data.AccessToken)
  } catch (e) {
    console.error(e)
    window.location.href = '/sign-out'
  }
}

export const cleanTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN)
  localStorage.removeItem(ID_TOKEN)
  localStorage.removeItem(REFRESH_TOKEN)
  localStorage.removeItem(LOGIN_TYPE)
  localStorage.removeItem(USER_PREFERENCE)
}

export const setTokens = (idToken: string, accessToken: string, refreshToken: string) => {
  localStorage.setItem(ID_TOKEN, idToken)
  localStorage.setItem(ACCESS_TOKEN, accessToken)
  localStorage.setItem(LOGIN_TYPE, TLoginType.DIRECT)
  localStorage.setItem(REFRESH_TOKEN, refreshToken)
}

export const setNewToken = (idToken: string, accessToken: string) => {
  localStorage.setItem(ID_TOKEN, idToken)
  localStorage.setItem(ACCESS_TOKEN, accessToken)
}

export const getAuthToken = async () => {
  const token = localStorage.getItem(ACCESS_TOKEN)
  const loginType = localStorage.getItem(LOGIN_TYPE)

  if (!token && loginType === TLoginType.THIRD_PARTY) {
    const session = await fetchAuthSession()
    return session.tokens?.accessToken?.toString() ?? null
  }
  return token
}
